import React from 'react';

const HomeOwnershipFilterIcon = (props: any) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.5801 17.107V16.7868C11.5824 15.8743 12.3213 15.1351 13.2334 15.1328H15.8476C16.7597 15.1351 17.4986 15.8743 17.5009 16.7868V17.107V17.107C17.5009 17.3252 17.3241 17.5021 17.1059 17.5021H11.9742C11.7564 17.5017 11.5801 17.3249 11.5801 17.107V17.107Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.5333 13.1583C13.6617 13.1567 12.9562 12.4493 12.957 11.5777C12.9578 10.7061 13.6646 10 14.5362 10C15.4078 10 16.1146 10.7061 16.1154 11.5777C16.1162 12.4493 15.4107 13.1567 14.5391 13.1583H14.5333Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.5 8.91404L9.11254 3.24603C9.62321 2.80829 10.3768 2.80829 10.8875 3.24603L17.5 8.91404"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.4286 8.01051V3.18182C16.4286 3.00099 16.3568 2.82756 16.2289 2.6997C16.1011 2.57183 15.9276 2.5 15.7468 2.5H13.7013C13.3248 2.5 13.0195 2.80526 13.0195 3.18182V5.08833"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.95508 16.668V12.3498C7.95508 11.9732 8.26047 11.668 8.63719 11.668H10.0014"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M3.57309 8.01172V16.6679" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M9.16667 16.6668H2.5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default HomeOwnershipFilterIcon;
